import { render } from "./BlackListePage.vue?vue&type=template&id=21356fa6&ts=true"
import script from "./BlackListePage.vue?vue&type=script&lang=ts"
export * from "./BlackListePage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__